<template>
  <div class="container-fluid py-4">

    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-person fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Patients</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" @click="creation()" v-if="$store.getters.hasPermission('PATIENT_CREATE')">
        <i class="bi bi-plus-circle me-1"></i>
      </button>
    </div>

    <!-- Filtres et recherche -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input type="text" v-model="searchQuery" placeholder="Nom, prénom, téléphone..." class="form-control form-control-clinique">
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-3">Chargement des patients...</p>
    </div>

    <!-- Tableau moderne -->
    <div v-else class="card shadow-sm rounded card-clinique">
      <div class="table-responsive overflow-auto">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>N° Dossier</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th class="d-none d-sm-table-cell">Adresse</th>
              <th class="d-none d-sm-table-cell">Téléphone</th>
              <th class="d-none d-md-table-cell">Nbre. Consultation</th>
              <th class="d-none d-md-table-cell">Consult-Terminée</th>
              <th class="d-none d-lg-table-cell">Enregistré par</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(patient, index) in filteredpatients" :key="patient.id" >
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ formatDate(patient.createdAt) }}</td>
              <td>{{ patient.numeroDossier }}</td>
              <td>{{ patient.nom }}</td>
              <td>{{ patient.prenom }}</td>
              <td class="d-none d-sm-table-cell">{{ patient.adresse }}</td>
              <td class="d-none d-sm-table-cell">{{ patient.telephone }}</td>
              <td class="d-none d-md-table-cell">{{ patient.nombreConsultations }}</td>
              <td class="d-none d-md-table-cell">{{ patient.nombreConsultationsTerminees }}</td>
              <td class="d-none d-lg-table-cell"><strong>{{ patient.createdByNom }} {{ patient.createdByPrenom }}</strong></td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="$store.getters.hasPermission('PATIENT_DOSSIER')"><a class="dropdown-item" @click="dossier(patient.id)">Dossier</a></li>
                    <li v-if="$store.getters.hasPermission('PATIENT_EDIT')"><a class="dropdown-item" @click="modifier(patient.id)">Modifier</a></li>
                    <li v-if="$store.getters.hasPermission('PATIENT_DELETE')"><a class="dropdown-item text-danger" @click="supprimer(patient.id)">Supprimer</a></li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="patients.length === 0">
              <td colspan="10" class="text-center py-3">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern flex-wrap mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      isLoading: true,
      isFirstLoad: true,
      searchQuery: '',
      itemsperpage: 50,
      orderBy: 'pat.createdAt',
      sortOrder: 'desc',
      patients: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [50, 100, 150, 200],
      orderByTabs: {
        Nom: 'pat.nom',
        Prénom: 'pat.prenom',
        Création: 'pat.createdAt'
      },
      sortOrders: { Croissant: 'asc', Décroissant: 'desc' }
    };
  },
  computed: {
    filteredpatients() {
      if (!this.searchQuery) return this.patients;
      const q = this.searchQuery.toLowerCase();
      return this.patients.filter(patient =>
        patient.nom.toLowerCase().includes(q) ||
        patient.prenom.toLowerCase().includes(q) ||
        patient.telephone.toLowerCase().includes(q) ||
        patient.numeroDossier?.toLowerCase().includes(q) ||
        dayjs(patient.createdAt).format('DD-MM-YYYY HH:mm').includes(q)
      );
    },
    totalPages() { return Math.ceil(this.totalItems / this.itemsperpage); }
  },
  methods: {
    formatDate(date) { return dayjs(date).format('DD-MM-YYYY HH:mm'); },
    creation() { this.$router.push({ name: 'create_patient' }); },
    dossier(id) { 
      this.$router.push({ name: 'information_personnelle', params: { id } });
     },
    modifier(id) { this.$router.push({ name: 'edit_patient', params: { id } }); },
    async getpatients() {
      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      }
      try {
        const response = await api.getItems('patients', {
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          itemsperpage: this.itemsperpage,
          page: this.currentPage,
          search: this.searchQuery
        });
        const { data, meta } = response.data;
        this.patients = data;
        this.totalItems = meta?.total_records ?? data.length;
      } catch (error) {
        console.error('Erreur lors de la récupération des patients :', error);
      } finally {
        this.isLoading = false;
      }
    },
    async supprimer(id) {
      if (!window.confirm("Voulez-vous vraiment supprimer ce patient ?")) return;
      try {
        await api.deleteItem('patients', id);
        this.getpatients();
      } catch {
        alert("Erreur lors de la suppression.");
      }
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.getpatients();
      }
    }
  },
  watch: {
    searchQuery() { this.currentPage = 1; this.getpatients(); },
    itemsperpage() { this.currentPage = 1; this.getpatients(); },
    orderBy() { this.getpatients(); },
    sortOrder() { this.getpatients(); }
  },
  created() { this.getpatients(); }
};
</script>

<style scoped>
/* ton CSS existant reste inchangé */
</style>
